import React from 'react'
import styles from './Button.scss'
import PropTypes from 'prop-types'
import { filter } from 'lodash'

const DisabledReason = ({children}) => (
  <div className={styles.disabledReason}>
    <div className={styles.content}>
      {children}
    </div>
  </div>
)

const Button = ({children, as, disabled, primary, success, dark, secondary, borderLight, borderDashed, radius, large, huge, widthAuto, widthWide, onClick, className, icon, disabledReason = null, ...rest}) => {
  const Button = as
  const ButtonColor = primary ? 'blue' : (success ? 'green': (dark ? 'gray' : (secondary ? 'secondary' : 'default')))
  const ButtonBorder = borderDashed ? styles.dashed : (borderLight ? styles.light : null)
  const ButtonSize = huge ? styles.huge : (large ? styles.large : styles.small)
  const ButtonDisabled = disabled ? styles[`${ButtonColor}Disabled`] : styles[ButtonColor]
  const ButtonRadius = radius ? styles[large ? 'radiusLarge' : 'radius'] : null
  const ButtonWidth = widthAuto ? styles.widthAuto : (widthWide ? styles.widthWide: null)

  const ButtonClass = filter([ButtonSize, ButtonDisabled, ButtonRadius, ButtonWidth, ButtonBorder, className]).join(' ')

  return (
    <Button className={ButtonClass} onClick={disabled ? undefined : onClick} disabled={disabled} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}{children}
      {disabled && !!disabledReason && <DisabledReason>{disabledReason}</DisabledReason>}
    </Button>
  )
}

Button.propTypes = {
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  success: PropTypes.bool,
  dark: PropTypes.bool,
  secondary: PropTypes.bool,
  radius: PropTypes.bool,
  large: PropTypes.bool,
  huge: PropTypes.bool,
  widthAuto: PropTypes.bool,
  widthWide: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.object
}

Button.defaultProps = {
  as: 'div',
  className: ''
}

export default Button
